import { Linking, TouchableOpacity, View } from "react-native"
import BackflipDude from "@/assets/clipart/backflip-dude.svg"
import Phone from "@/assets/clipart/phone.svg"
import GiftBox from "@/assets/clipart/gift-box.svg"
import House from "@/assets/clipart/house.svg"
import { Body, H2, H5, Tiny } from "@/components/standard/BFText"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import type { ReactNode } from "react"

interface PointsSectionProps {
  title: string
  subtitle: string
  description: string
  image: ReactNode
  imageFirst: boolean
}

const PointsSection: React.FC<PointsSectionProps> = ({
  title,
  subtitle,
  description,
  image,
  imageFirst,
}: PointsSectionProps) => (
  <View className="flex flex-col">
    <H5 className="text-midnight-blue pb-6">{title}</H5>
    {imageFirst ? (
      <View className="flex flex-row items-center justify-center px-4">
        <View>{image}</View>
        <View className="flex flex-col flex-1 pl-6">
          <H2 className="text-calm-blue">{subtitle}</H2>
          <Body className="text-midnight-blue pt-1">{description}</Body>
        </View>
      </View>
    ) : (
      <View className="flex flex-row items-center justify-center pr-6">
        <View className="flex flex-col flex-1 px-4">
          <H2 className="text-calm-blue">{subtitle}</H2>
          <Body className="text-midnight-blue pt-1">{description}</Body>
        </View>
        <View>{image}</View>
      </View>
    )}
  </View>
)

const PointsSectionDivider = () => (
  <View className="flex h-px bg-light-grey my-6" />
)

interface EarningPointsTabProps {
  onRefer: () => void
}

export const EarningPointsTab: React.FC<EarningPointsTabProps> = ({
  onRefer,
}: EarningPointsTabProps) => {
  return (
    <View className="flex flex-col flex-1 p-6 px-8">
      <PointsSection
        title="Becoming a Backflip Member:"
        subtitle="10 Referrals"
        description="You receive 10 referrals towards earning reward points"
        image={<BackflipDude width={95} height={138} />}
        imageFirst={true}
      />
      <PointsSectionDivider />
      <PointsSection
        title="When You Refer a Friend:"
        subtitle="500 Points per referral"
        description="You receive points each time a referral signs up with Backflip"
        image={<Phone width={105} height={140} />}
        imageFirst={false}
      />
      <PointsSectionDivider />
      <PointsSection
        title="When A Referral Closes on a Loan:"
        subtitle="1,000 Points"
        description="You receive the points on top of the referral points when they close on their first deal"
        image={<GiftBox width={114} height={115} />}
        imageFirst={true}
      />
      <PointsSectionDivider />
      <PointsSection
        title="When You Close on a Backflip Loan:"
        subtitle="10 Referrals"
        description="You get additional 10 referrals for every loan you close with us"
        image={<House width={147} height={125} />}
        imageFirst={false}
      />
      <View className="flex flex-col p-4 mt-6 border border-midnight-blue">
        <H5 className="text-midnight-blue">Gift A Friend!</H5>
        <Body className="text-midnight-blue pt-2">
          Each friend you refer receives 1,000 free points to get started!
        </Body>
      </View>
      <View className="mt-6">
        <PrimaryButton
          testID={"refer-button"}
          title="Refer a Friend"
          onPress={onRefer}
        />
      </View>
      <View className="flex items-center mb-9">
        <TouchableOpacity
          testID={"terms-and-conditions-link-button"}
          onPress={() => {
            void Linking.openURL(
              "https://dobackflip.com/backflip-rewards/?appDisplay=true"
            )
          }}
        >
          <Tiny className="text-calm-blue underline pt-4">
            See Terms & Conditions
          </Tiny>
        </TouchableOpacity>
      </View>
    </View>
  )
}
